import React from "react";
import { FunctionField, ShowProps, TextField } from "react-admin";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import Schedule from "./Schedule";
import PricingPolicyField from "./components/PricingPolicyField";
import StatusField from "../../components/StatusField";
import CcaDetail from "./CcaDetail";
import CcaSchedule from "./CcaSchedule";
import { paymentMethodType } from "./const";
import CustomLabeled from "../../components/layout/CustomLabeled";
import CustomPriceField from "../../components/CustomPriceField";
import CustomBooleanField from "../../components/CustomBooleanField";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  const paymentMethodTypeFormatter = (id: string, source: any): string => {
    const item = source.find((type: any) => type.id === id);
    return item ? item.name : "-";
  };

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">School Detail</Typography>

          <Button
            className={classes.summaryButton}
            variant="contained"
            color="primary"
            component={Link}
            to={{
              pathname: `/schools/${Number(props.id)}`,
            }}
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomLabeled name="Id">
                <TextField source="id" emptyText="-" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={12}>
              <CustomLabeled name="Email">
                <TextField source="email" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Phone">
                <TextField source="phone" emptyText="-" />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2} style={{ borderLeft: "1px solid #ccc" }}>
            <Grid item xs={12}>
              <CustomLabeled name="School Prefix">
                <TextField source="schoolPrefix" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Pre va and beacon">
                <TextField source="virtualAccountPrefix" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Mbc Code">
                <TextField source="mbcCode" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Type for Student Area Distance Calculation">
                <TextField source="areaDistanceCalculationType" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Type for Subcontractor Area Distance Calculation">
                <TextField
                  source="subcontractorAreaDistanceCalculationType"
                  emptyText="-"
                />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2} style={{ borderLeft: "1px solid #ccc" }}>
            <Grid item xs={12}>
              <CustomLabeled name="Pricing Policy">
                <PricingPolicyField source="isFullCalendarDaysCharge" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Type for Parent Payment Method">
                <FunctionField
                  render={(record: any) =>
                    paymentMethodTypeFormatter(
                      record.paymentMethodType,
                      paymentMethodType,
                    )
                  }
                />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Allow Custom Pickup and Dropoff Location In Routeplan">
                <CustomBooleanField
                  source="isCustomPickupAndDropoffLocationAllowedForRouteplan"
                  textForTrueValue="Yes"
                  textForFalseValue="No"
                />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Status">
                <StatusField source="status" />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Address
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <CustomLabeled name="address">
            <TextField source="address" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Block No.">
            <TextField source="blockNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Building Name">
            <TextField source="building" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="postalCode">
            <TextField source="postalCode" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={12}>
          <FunctionField
            addLabel={false}
            render={(record: any) =>
              record?.isStudentSubsidyEnable ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} style={GridinRowsWithSpace}>
                    <Typography variant="h6" gutterBottom>
                      Student Subsidy Setting
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <CustomLabeled name="Max Bus Fare Cap">
                      <CustomPriceField
                        source="maximumStudentSubsidy"
                        record={record}
                      />
                    </CustomLabeled>
                  </Grid>

                  <Grid item xs={12}>
                    <CustomLabeled name="Subsidy Description Format">
                      <TextField source="subsidyDescriptionPrefix" emptyText="-" />
                    </CustomLabeled>
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12} style={GridinRowsWithSpace}>
                  <Typography variant="h6" gutterBottom>
                    Student Subsidy Setting is Disabled
                  </Typography>
                </Grid>
              )
            }
          />
        </Grid>

        <Grid item xs={12}>
          <CcaDetail {...props} />
        </Grid>

        <Grid item xs={12}>
          <Schedule {...props} />
        </Grid>

        <Grid item xs={12}>
          <CcaSchedule {...props} />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
